import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { User } from "../../../../../domain/user/User";
import { Paths } from "../../../../../Paths";
import { deleteUserAction } from "../../../../../state/usecase/admin/user/actions";
import { useAuthUser } from "../../../../hooks/auth/useAuthUser";
import { Button } from "../../../common/button/Button";
import { Loading } from "../../../common/Loading";
import { NoData } from "../../../common/no_data/NoData";
import { useNavigate } from "react-router-dom";

export const UserList = React.memo(function UserList(props: Props) {
    const { userList } = props;

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const authUser = useAuthUser();

    const handleEditClicked = useCallback((user: User) => () =>
        navigate(`${Paths.admin}${Paths.user}${Paths.edit}/${user.id.value}`)
    , [navigate]);

    const handleDeleteClicked = useCallback((user: User) => () => {
        console.table(user);
        console.table(authUser);
        if (user.id.value === authUser.id.value) {
            alert("自分自身のアカウントは削除できません。");
            return;
        }

        if (!window.confirm(`${user.name.value}を削除しますか？`)) return;

        dispatch(
            deleteUserAction({
                userId: user.id
            })
        );
    }, [dispatch]);

    return (
        <tbody>
            {/* レスポンス取得中：ローディング表示 */}
            {/* データ0件：データ無し表示 */}
            {/* 上記以外：リスト表示 */}
            {!userList ? (
                <tr>
                    <td colSpan={3}>
                        <Loading />
                    </td>
                </tr>
            ) : !userList.length ? (
                <tr>
                    <td colSpan={3}>
                        <NoData />
                    </td>
                </tr>
            ) : (
                <>
                    {userList.map((user) => (
                        <tr key={user.id.value}>
                            <td>{user.name.value}</td>
                            <td>{user.email.value}</td>
                            <td>
                                <div className="button_area">
                                    <Button label={"編集"} colorReversed={true} onClick={handleEditClicked(user)} />
                                    <Button label={"削除"} colorReversed={true} onClick={handleDeleteClicked(user)} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </>
            )}
        </tbody>
    );
});

type Props = {
    userList: User[] | null
};
